import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "App-Survey-Rate" }
const _hoisted_2 = { "txt-center": "" }
const _hoisted_3 = { class: "App-Survey-Rate-H" }
const _hoisted_4 = { class: "App-Survey-Rate-Item" }
const _hoisted_5 = {
  "f-w-600": "",
  "h-tb-0": ""
}
const _hoisted_6 = { class: "App-Survey-Rate-In" }
const _hoisted_7 = { class: "App-Survey-Rate-In-M" }
const _hoisted_8 = {
  "txt-center": "",
  "m-t-2": ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_QuestionFilled = _resolveComponent("QuestionFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_slider = _resolveComponent("el-slider")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _cache[0] || (_cache[0] = _createElementVNode("h1", {
        "m-tb-1": "",
        "txt-center": ""
      }, "Entrepreneurial Assessment", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("p", {
        "f-w-600": "",
        "txt-center": "",
        dark: "",
        "txt-120": ""
      }, " Use the slider to distribute entrepreneurial points to the following entrepreneurial dimensions based on how your founding team currently stands. ", -1)),
      _createVNode(_component_el_divider),
      _cache[2] || (_cache[2] = _createElementVNode("p", { "txt-center": "" }, " You have 32 points to distribute to the entrepreneurial dimensions below where each dimension can get points between 0 and 8. ", -1)),
      _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.remaining), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_space, {
        direction: "vertical",
        "w-100": "",
        fill: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.glossary, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `CatL${item.dimension}`
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", null, [
                  _createVNode(_component_el_space, { size: 10 }, {
                    default: _withCtx(() => [
                      _createElementVNode("h4", _hoisted_5, _toDisplayString(_ctx.$filters.capitalize(_ctx.dimensionFull(item.dimension))), 1),
                      _createElementVNode("span", null, [
                        _createVNode(_component_el_popover, {
                          placement: "top-start",
                          title: _ctx.$filters.capitalize(_ctx.dimensionFull(item.dimension)),
                          width: 200,
                          trigger: "hover",
                          content: item.description
                        }, {
                          reference: _withCtx(() => [
                            _createVNode(_component_el_icon, {
                              style: {"display":"flex"},
                              size: 16
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_QuestionFilled)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["title", "content"])
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_slider, {
                      "w-100": "",
                      label: _ctx.dimensionFull(item.dimension),
                      "show-stops": "",
                      step: 1,
                      max: 8,
                      min: 0,
                      "input-size": "large",
                      modelValue: _ctx.score[item.dimension],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.score[item.dimension]) = $event),
                      "show-tooltip": "",
                      onInput: ($event: any) => (_ctx.inputDim(item.dimension, $event))
                    }, null, 8, ["label", "modelValue", "onUpdate:modelValue", "onInput"]),
                    _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.score[item.dimension]), 1)
                  ])
                ])
              ])
            ]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_el_button, {
        icon: "el-icon-check",
        onClick: _ctx.submitSurvey,
        size: "large",
        type: "primary",
        "is-block": "",
        disabled: !_ctx.canSubmit
      }, {
        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
          _createTextVNode(" Save ", -1)
        ]))]),
        _: 1
      }, 8, ["onClick", "disabled"])
    ])
  ])), [
    [_directive_loading, _ctx.loading]
  ])
}